<script setup lang="ts">
import { UserManagement } from '@descope/vue-sdk';
import { Loader2 } from 'lucide-vue-next';
import { ref } from 'vue';

import { useTenantStore } from '@/stores/tenant';

const tenantStore = useTenantStore();
const isReady = ref(false);

const onReady = () => {
    isReady.value = true;
};
</script>

<template>
    <div class="title flex flex-col gap-6 min-h-full">
        <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold">User management</h2>
            <p class="text-sm text-muted-foreground">
                Manage users and their roles.
            </p>
        </div>
        <div class="user-management-wrapper flex-1 overflow-x-auto">
            <div
                v-if="!isReady"
                id="loader"
                class="h-full w-full flex items-center justify-center"
            >
                <Loader2 class="animate-spin h-6 w-6 text-gray-400" />
            </div>
            <div :class="isReady ? 'opacity-100' : 'opacity-0'">
                <UserManagement
                    @ready="onReady"
                    :tenant="tenantStore.tenantId ?? ''"
                    widget-id="user-management-widget"
                    theme="light"
                    class="h-full"
                />
            </div>
        </div>
    </div>
</template>
